import { StepperMessage } from '../../../common/enums/message.enum';
import { FlowContext } from './flow.types';

export enum StepperStatus {
    NotStarted = 'notStarted',
    InProgress = 'inProgress',
    Completed = 'completed'
}

/** One page inside a stepper section. */
export interface StepperChildDefinition {
    route: string;
    /**
     * Whether the page belongs to the agent's path before it is reached. Without it the page always shows;
     * a page the agent has visited always shows.
     */
    when?: (ctx: FlowContext) => boolean;
    /** Page that must be finished before any product flow starts, so it counts as done once the flow is entered. */
    doneOnEntry?: boolean;
}

/** One top-level step (Programming, Hardware, Credit Check, ...). */
export interface StepperSectionDefinition {
    id: string;
    label: StepperMessage;
    children: StepperChildDefinition[];
}

/** Sections in display order for the agent's current product and selections. */
export type StepperFlowDefinition = (ctx: FlowContext) => StepperSectionDefinition[];

export interface StepperRingSegment {
    dashArray: string;
    dashOffset: number;
    completed: boolean;
}

export interface StepperChildView {
    route: string;
    title: string;
    status: StepperStatus;
    current: boolean;
}

export interface StepperSectionView {
    id: string;
    label: StepperMessage;
    number: number;
    status: StepperStatus;
    current: boolean;
    done: number;
    total: number;
    children: StepperChildView[];
    ring: StepperRingSegment[];
}

export interface StepperView {
    sections: StepperSectionView[];
    /** Leading completed sections collapsed into the green "N done" pill (two or more). */
    groupedCount: number;
    completedCount: number;
    readyToFinalize: boolean;
    locked: boolean;
}
